export function agreementTextHasContent(html: string | null | undefined): boolean {
    if (!html) {
        return false;
    }

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const visibleText = (parsed.body.textContent || '').replace(/\u00a0/g, ' ').trim();

    return visibleText !== '' || parsed.body.querySelector('img') !== null;
}
